import HeaderAccount from './HeaderAccount';

export default HeaderAccount;
